import { Icon } from '@chakra-ui/react';

const PCIcon = (props) => (
	<Icon
		version="1.1"
		id="Layer_1"
		x="0px"
		y="0px"
		viewBox="0 0 30 30"
		fill={'#4A5668'}
		// style="enable-background:new 0 0 1500 1500;"
		{...props}>

		<path class="st0" d="M18.81,18.83c2.8,0,5.42,0,8.04,0c1.59,0,2.49,0.91,2.49,2.51c0,1.84,0,3.68,0,5.52c0,1.65-0.91,2.55-2.61,2.55
	c-5.5,0.01-11,0-16.5,0c-2.29,0-4.58,0-6.87,0c-1.87,0-2.75-0.87-2.75-2.71c0-7.76,0.02-15.53-0.02-23.29
	C0.58,1.8,1.52,0.6,3.34,0.68C5.08,0.76,6.83,0.7,8.58,0.7c1.78,0,2.62,0.86,2.62,2.66c0,2.62,0,5.24,0,8.03
	c0.27-0.25,0.45-0.41,0.61-0.58c2.79-2.79,5.58-5.57,8.37-8.36c1.35-1.35,2.54-1.35,3.9,0c1.22,1.22,2.44,2.43,3.66,3.65
	c1.27,1.27,1.27,2.49,0.02,3.75c-2.77,2.77-5.54,5.54-8.31,8.31C19.26,18.34,19.09,18.53,18.81,18.83z M9.63,27.89
	c0.02-0.17,0.04-0.24,0.04-0.31c0-8.14,0-16.28,0.01-24.42c0-0.66-0.29-0.95-0.94-0.94c-1.79,0.01-3.59,0-5.38,0
	c-1.08,0-1.23,0.14-1.23,1.22c0,7.74,0,15.48,0,23.22c0,0.17-0.06,0.38,0.02,0.49c0.21,0.27,0.47,0.71,0.72,0.71
	C5.11,27.91,7.34,27.89,9.63,27.89z M11.2,24.15c0.16-0.1,0.22-0.12,0.27-0.17c5.11-5.1,10.22-10.21,15.33-15.32
	c0.5-0.5,0.49-0.87-0.03-1.39c-1.3-1.31-2.6-2.61-3.91-3.9c-0.57-0.56-0.89-0.58-1.44-0.02c-3.31,3.3-6.62,6.6-9.91,9.92
	c-0.16,0.16-0.29,0.44-0.3,0.66C11.19,17.3,11.2,20.67,11.2,24.15z M11.26,27.84c0.09,0.02,0.13,0.04,0.17,0.04
	c5.15,0,10.3,0,15.45,0.01c0.65,0,0.94-0.31,0.93-0.96c-0.01-1.84,0-3.68,0-5.52c0-0.91-0.15-1.06-1.09-1.06
	c-2.98,0-5.95-0.01-8.93,0.01c-0.31,0-0.69,0.16-0.91,0.38c-1.64,1.6-3.21,3.27-4.89,4.83C11.28,26.23,11.05,26.91,11.26,27.84z"/>

	</Icon>
);

export default PCIcon;
